import React from "react";
import Slider from "react-slick";
import PropTypes from "prop-types";

import "./styles.scss";

import { Container, Row, Col } from "reactstrap";

const Partners = ({ partners }) => {
    const settings = {
        dots: false,
        arrows: false,
        className: "center",
        centerMode: true,
        infinite: true,
        centerPadding: "60px",
        speed: 4000,
        autoplaySpeed: 4000,
        autoplay: true,
        slidesToShow: 6,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 4
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2
                }
            }
        ]
    };

    return (
        <Container fluid tag="section" className="partners py-5">
            <Row>
                <Col xs="12" className="text-center">
                    <h2 className="title">Nuestros partners</h2>
                </Col>
                <Col className="pt-5">
                    <Slider {...settings}>
                        {partners.map((partner, i) => (
                            <div key={i} className="text-center">
                                <img src={`/images/logos/${partner.image}.png`} alt={partner.name} title={partner.name} className="img-fluid d-inline" />
                            </div>
                        ))}
                    </Slider>
                </Col>
            </Row>
        </Container>
    );
};

Partners.propTypes = {
    partners: PropTypes.arrayOf(PropTypes.object).isRequired
};

export default Partners;